


















































import { PropType } from 'vue';
import { dateFormatEnum } from '../../enums/dateFormatEnum';
import { EventInviteeModel } from '../../models/eventInvitee.model';
import { DateTimeUtil } from '../../utils/dateTimeUtil';
import { InstitutionProfileModel } from '../../models/institutionProfile.model';

export default {
  props: {
    slotData: { type: Object, required: true },
    timeslotId: { type: Number, required: true },
    invitees: { type: Array as PropType<Array<EventInviteeModel>>, required: true },
    answers: { type: Array, required: true },
    regardingProfile: { type: Object as PropType<InstitutionProfileModel>, default: null },
    numberOfSlots: { type: Number, default: 1 },
    index: { type: Number, required: true },
  },
  emits: ['selectSlot'],
  computed: {
    slotValue() {
      return {
        timeslotId: this.timeslotId,
        index: this.index,
      };
    },
    startTime() {
      return DateTimeUtil.formatDate(this.slotData.startTime, dateFormatEnum.SHORT_TIME);
    },
    endTime() {
      return DateTimeUtil.formatDate(this.slotData.endTime, dateFormatEnum.SHORT_TIME);
    },
    acceptedInvitees() {
      const answeredInviteeIds = this.answers.map(answer => answer.concerningProfile?.id);
      return this.invitees.filter(invitee => answeredInviteeIds.includes(invitee.instProfile.id));
    },
    blockedAnswers() {
      return this.answers.filter(answer => answer.instProfile == null);
    },
    isAccepted() {
      return this.answers.some(answer => answer.concerningProfile?.profileId === this.regardingProfile?.id);
    },
    numberOfSlotsRemaining() {
      return this.numberOfSlots - this.acceptedInvitees.length - this.blockedAnswers.length;
    },
  },
  methods: {
    selectSlot() {
      this.$emit('selectSlot');
    },
  },
};
